module.exports = __webpack_public_path__ + "static/bottomLeftAbout-f2310060a091b9d48386a3abfb51eb64.png";